import { render } from "./MediaDocsLinksDialog.vue?vue&type=template&id=5bc14bc5&scoped=true"
import script from "./MediaDocsLinksDialog.vue?vue&type=script&lang=js"
export * from "./MediaDocsLinksDialog.vue?vue&type=script&lang=js"

import "./MediaDocsLinksDialog.vue?vue&type=style&index=0&id=5bc14bc5&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc14bc5"]])

export default __exports__